import { colorStyle, useColorMode } from '@tonic-ui/react';

export const customColorStyle = {
  ...colorStyle,
  dark: {
    ...colorStyle.dark,
    centeredLayout: {
      borderColor: 'gray:80',
    },
    support: {
      backgroundColor: 'gray:90',
      resourceText: 'white:emphasis',
      tagBackground: 'gray:70',
      tagText: 'gray:20',
      border: 'rgba(255, 255, 255, 0.12)',
      divider: 'gray:70',
      check: 'green:40',
      placeholderColor: 'white:tertiary',
      invalidBgColor: 'red:60',
      invalidBorderColor: 'red:50',
      errorText: 'red:60',
      borderColor: 'gray:60',
      focusBorderColor: 'blue:60',
    },
  },
  light: {
    ...colorStyle.light,
    centeredLayout: {
      borderColor: 'gray:20',
    },
    support: {
      backgroundColor: 'white:primary',
      resourceText: 'black:primary',
      tagBackground: 'gray:20',
      tagText: 'gray:100',
      border: 'gray:20',
      divider: 'gray:20',
      check: 'green:50',
      placeholderColor: 'black:tertiary',
      invalidBgColor: 'red:60',
      invalidBorderColor: 'red:60',
      errorText: 'red:50',
      borderColor: 'gray:30',
      focusBorderColor: 'blue:60',
    },
  },
};
